import { render } from "./IssueReviewComponent.vue?vue&type=template&id=3f6f6a6a&scoped=true&ts=true"
import script from "./IssueReviewComponent.vue?vue&type=script&lang=ts"
export * from "./IssueReviewComponent.vue?vue&type=script&lang=ts"

import "./IssueReviewComponent.vue?vue&type=style&index=0&id=3f6f6a6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6f6a6a"]])

export default __exports__